module.exports = __webpack_public_path__ + "static/Deeplearning-b1d5910b500fd2b074a10f2ad0d5fc8a.jpg";